
// Timers spawned by the slide-ready poll below, so a rebuild can clear the
// previous round rather than letting them accumulate.
const pendingSlidePolls = new Set();

function initializeSwiper(buildSlide) {
  if ( window.innerWidth < 720) {
    import(flu.chunks.swiper).then(({ Swiper, Pagination }) => {
      const containerDOMItemsMediaTest = document.querySelectorAll('[data-slide-images-product]');
      containerDOMItemsMediaTest.forEach((container, index) => {
        if (container.swiper) {
          container.swiper.destroy(true, true);
        }
        
        const paginationEl = container.querySelector(".swiper-pagination");
        if (!paginationEl) {
          console.error(`Pagination element not found for slider ${index}`);
          return;
        }

        const swiper = new Swiper(container, {
          modules: [Pagination],
          loop: true,
          pagination: {
            el: paginationEl,
            clickable: true,
            bulletElement: 'button',
            renderBullet: function (index, className) {
              return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
            },
          },
          on: {
            init: function () {
              const swiperInstance = this;
              let attempts = 0;
              // This used to re-arm forever when slides.length !== 5, which is the
              // normal state after the first pass removes a slide. Every resize
              // therefore left another permanent 1s timer behind.
              const checkSlidesReady = () => {
                if (swiperInstance._destroyed) return;
                if (swiperInstance.slides && swiperInstance.slides.length === 5) {
                  swiperInstance.slides[buildSlide].remove();
                  if (typeof swiperInstance.update === 'function') swiperInstance.update();
                  return;
                }
                if (++attempts >= 5) return;
                const id = setTimeout(checkSlidesReady, 1000);
                pendingSlidePolls.add(id);
              };
              checkSlidesReady();
            },
            paginationRender: function (swiper, paginationEl) {
              //console.log(`Pagination rendered for container ${index}`);
            },
            touchStart: function (swiper, event) {
              event.stopPropagation();
            },
            sliderMove: function (swiper, event) {
              event.stopPropagation();
            },
          },
        });

        container.swiper = swiper;
      });
    }).catch(error => console.error('Error loading Swiper:', error));
  }
}

initializeSwiper(2);

// Debounced. On mobile, showing/hiding the address bar fires resize constantly,
// and every one of those was tearing down and rebuilding every carousel.
let swiperInitTimer;
window.addEventListener('resize', () => {
  clearTimeout(swiperInitTimer);
  swiperInitTimer = setTimeout(() => {
    pendingSlidePolls.forEach(clearTimeout);
    pendingSlidePolls.clear();
    initializeSwiper(2);
  }, 250);
});

function addStickyToTopRibbon() {
  let bar = document.querySelector(".shopify-section.shopify-section-group-header-group.announcement-bar__outer-wrapper")
  if (bar){
    window.onscroll = function() { stickNavBar() };
    let previousPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    function stickNavBar() {
      const barHeight = bar.offsetHeight;
      const header = document.querySelector(".shopify-section.shopify-section-group-header-group.header__outer-wrapper");
      if (!header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = header.offsetHeight;
      
      // Ignore micro-scrolls to prevent touch jitter from rapidly toggling the header state
      if (Math.abs(scrollTop - previousPosition) < 15 && scrollTop > 0) {
        return;
      }
      
      bar.style.zIndex = "10";
      const isCurrentlySticky = bar.style.position === "sticky";
  
      if (scrollTop <= 0) {
        // At top page, clear sticky styles to attach them to the document natively
        bar.style.position = "";
        bar.style.top = "";
        bar.style.transition = "";
        header.style.position = "";
        header.style.top = "";
        header.style.transition = "";
      } else if (scrollTop > previousPosition) { // Scrolling down
        if (scrollTop > barHeight + headerHeight) {
          if (!isCurrentlySticky) {
            // Instantly hide them without transition to prevent flashing
            bar.style.transition = "none";
            header.style.transition = "none";
          } else {
            // Animate them away smoothly
            bar.style.transition = "top 0.1s ease-out";
            header.style.transition = "top 0.15s ease-out";
          }
          bar.style.position = "sticky";
          bar.style.top = `-${barHeight}px`;
          header.style.position = "sticky";
          header.style.top = `-${headerHeight}px`;
        } else {
          // Near the top of the page
          if (isCurrentlySticky) {
            // We were sticky from scrolling up, so animate away
            bar.style.transition = "top 0.1s ease-out";
            header.style.transition = "top 0.15s ease-out";
            bar.style.top = `-${barHeight}px`;
            header.style.top = `-${headerHeight}px`;
          } else {
            // We are natively scrolling down from 0, stay static
            bar.style.position = "static";
            header.style.position = "static";
            bar.style.transition = "none";
            header.style.transition = "none";
          }
        }
      } else if (scrollTop < previousPosition) { // Scrolling up
        bar.style.transition = "top 0.1s ease-out";
        header.style.transition = "top 0.15s ease-out";
        bar.style.position = "sticky";
        bar.style.top = "0px";
        header.style.position = "sticky";
        header.style.top = `${barHeight}px`;
      }
      previousPosition = scrollTop;
    }
  }
  }
  

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 959) {
    addStickyToTopRibbon();
  }
  window.addEventListener('resize', () => {
    if (window.innerWidth < 959) {
      addStickyToTopRibbon();
    }
  });
})

 // filters on PLP

document.getElementById('apply-dark-filter')?.addEventListener('click', function() {
    clearFiltersAndToggleCheckbox('filter--filter.p.m.details.swatch--Dark--sidebar', this);
});

document.getElementById('apply-maximum-filter')?.addEventListener('click', function() {
    clearFiltersAndToggleCheckbox('filter--filter.p.m.details.swatch--Maximum--sidebar', this);
});

document.getElementById('apply-medium-filter')?.addEventListener('click', function() {
    clearFiltersAndToggleCheckbox('filter--filter.p.m.details.swatch--Medium--sidebar', this);
});

document.getElementById('apply-ultra-dark-filter')?.addEventListener('click', function() {
    clearFiltersAndToggleCheckbox('filter--filter.p.m.details.swatch--Ultra%20Dark--sidebar', this);
});

function clearFiltersAndToggleCheckbox(checkboxId, button) {
    var collectionLoadingElement = document.querySelector('.collection__loading');
    var collectionProductsElement = document.querySelector('.collection__products');
    
    if (collectionLoadingElement && collectionProductsElement) {
        collectionLoadingElement.style.opacity = '1';
        collectionProductsElement.style.opacity = '0';
    }
    
    var clearFiltersButton = document.querySelector('.active-filters__clear');
    if (clearFiltersButton) {
        clearFiltersButton.click();
    } else {
        return;
    }
    
    var observer = new MutationObserver(function(mutations) {
        var filtersCleared = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
                filtersCleared = true;
            }
        });
        
        if (filtersCleared) {
            toggleCheckbox(checkboxId, button);
            observer.disconnect();
            
            if (collectionLoadingElement && collectionProductsElement) {
                setTimeout(function() {
                    collectionLoadingElement.style.opacity = '0';
                    collectionProductsElement.style.opacity = '1';
                }, 2000);
            }
        }
    });

    var activeFiltersContainer = document.querySelector('.active-filters');
    if (activeFiltersContainer) {
        observer.observe(activeFiltersContainer, { childList: true });
    }
}

function toggleCheckbox(checkboxId, button) {
    var filterCheckbox = document.getElementById(checkboxId);
    
    if (filterCheckbox) {
        filterCheckbox.checked = !filterCheckbox.checked;
                filterCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                if (filterCheckbox.checked) {
            button.classList.add('button-active');
        } else {
            button.classList.remove('button-active');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
  var paths = [
      '/collections/shop-all',
      '/collections/mousses',
      '/collections/purest',
      '/collections/gradual',
      '/collections/face',
      'collections/mousses',
      '/collections/accessories',
      '/collections/gifts-sets'
  ];
  
  var path = window.location.pathname;

  if ((window.currentTemplate || '').includes('collection')) {
      var style = document.createElement('style');
      style.innerHTML = `
          .filter-bar__button--filters {
              display: none;
          }
          .filter-bar__results-count {
              display: none;
          }
          .collection-banner__text-container-heading {
              display:none
          }
          .collection-banner__inner {
              display: none;
          }
          .filter-bar__inner {
              border-top: 1px solid #F7CED7;
          }
          .filter-bar__sort-group {
              margin-top: 80px;
          }
          .filter-b- {
              display: flex !important;
          }
          .filter-bar__sort-group {
              margin-top: 80px;
          }
          @media (min-width: 1200px) {
              .filter-bar__sort-group {
                  margin-top: 40px !important;
              }
          }
          .filter-b- {
              display: none;
              gap: 28px;
              margin-left: 62px;
              width: fit-content;
              position: relative;
              margin-top: -50px;
              z-index: 999;
              margin-bottom: 20px;
          }
          .active-filters__active-filter {
              display: none;
          }
          @media (max-width: 768px) {
              .mobile-filters {
                  display: none!important;
              }
              .filter-bar {
                  display: block!important;
                  width: 100%;
                  padding: 12px 0;
                  margin-top: 25px;
                  position: absolute;
              }
              .section.section--full-width {
                  padding: 5px !important;
              }
          }
      `;
      document.head.appendChild(style);

      if (path === '/collections/accessories') {
          var accessoryStyle = document.createElement('style');
          accessoryStyle.innerHTML = `
              @media (max-width: 768px) {
                  .blocks-module-cplp {
                      margin-bottom: -80px !important;
                  }
              }
          `;
          document.head.appendChild(accessoryStyle);
      }

      function hideElementById(id) {
          var element = document.getElementById(id);
          if (element) {
              element.style.display = 'none';
          }
      }

      switch(path) {
          case '/collections/mousses':
              hideElementById('apply-maximum-filter');
              break;
          case '/collections/purest':
              hideElementById('apply-maximum-filter');
              hideElementById('apply-ultra-dark-filter');
              break;
          case '/collections/face':
              hideElementById('apply-maximum-filter');
              hideElementById('apply-ultra-dark-filter');
              break;

                          case '/collections/mousses':
              hideElementById('apply-maximum-filter');
              hideElementById('apply-ultra-dark-filter');
              break;
          case '/collections/gradual':
              hideElementById('apply-maximum-filter');
              hideElementById('apply-ultra-dark-filter');
              break;
          case '/collections/accessories':
              hideElementById('apply-maximum-filter');
              hideElementById('apply-ultra-dark-filter');
              hideElementById('apply-dark-filter');
              hideElementById('apply-medium-filter');
              hideElementById('filter-b-text');
              break;
          case '/collections/gifts-sets':
              hideElementById('apply-maximum-filter');
              break;
      }
  }
});
